export default __webpack_public_path__ + "static/media/Home_Hover.ca1a6875.png";